var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavDashboardActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "075193CE-6947-4994-B120-E5F7984EB2A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 171.000000)",
    fill: "none",
    opacity: 0.147925967
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 245,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    id: "NavDashboard",
    transform: "translate(18.000000, 182.000000)",
    fill: "#898381",
    fillRule: "nonzero",
    stroke: "#898381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,3 C10.5522847,3 11,3.44771525 11,4 L11,10 C11,10.5522847 10.5522847,11 10,11 L4,11 C3.44771525,11 3,10.5522847 3,10 L3,4 C3,3.44771525 3.44771525,3 4,3 L10,3 Z M10,4 L4,4 L4,10 L10,10 L10,4 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,13 C10.5522847,13 11,13.4477153 11,14 L11,20 C11,20.5522847 10.5522847,21 10,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,14 C3,13.4477153 3.44771525,13 4,13 L10,13 Z M10,14 L4,14 L4,20 L10,20 L10,14 Z",
    id: "Rectangle-Copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3 C20.5522847,3 21,3.44771525 21,4 L21,10 C21,10.5522847 20.5522847,11 20,11 L14,11 C13.4477153,11 13,10.5522847 13,10 L13,4 C13,3.44771525 13.4477153,3 14,3 L20,3 Z M20,4 L14,4 L14,10 L20,10 L20,4 Z",
    id: "Rectangle-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,13 C20.5522847,13 21,13.4477153 21,14 L21,20 C21,20.5522847 20.5522847,21 20,21 L14,21 C13.4477153,21 13,20.5522847 13,20 L13,14 C13,13.4477153 13.4477153,13 14,13 L20,13 Z M20,14 L14,14 L14,20 L20,20 L20,14 Z",
    id: "Rectangle-Copy-6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboardActive);
export default __webpack_public_path__ + "static/media/NavDashboardActive.d07c7956ede1b7082fb91cc33be56de9.svg";
export { ForwardRef as ReactComponent };